<template>
  <div
    class="editor-mask"
    @mousedown="handleMouseDown"
  >
    <slot :style="style">
      <div class="editor" :style="style">
        <Container />
      </div>
    </slot>
  </div>
</template>
<script>
import Container from '../container'
export default {
  name: 'ICScreenEditor',
  components: {
    Container
  },
  inject: [
    'layers',
    'addLayer',
    'updateLayer'
  ],
  provide () {
    return {
      mode: 'screen',
      addLayer: this.addLayer,
      moveLayer: this.moveLayer,
      moveCanvas: this.moveCanvas,
    }
  },
  mounted () {
    window.addEventListener('mousemove', this.handleWindowMouseMove)
    window.addEventListener('mouseup', this.handleWindowMouseUp)
    window.addEventListener('keydown', this.handleWindowKeydown)
    window.addEventListener('keyup', this.handleWindowKeyUp)

    this.$EventBus.$on('updateLayer', this.updateLayer)
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.handleWindowMouseMove)
    window.removeEventListener('mouseup', this.handleWindowMouseUp)
    window.removeEventListener('keydown', this.handleWindowKeydown)
    window.removeEventListener('keyup', this.handleWindowKeyUp)

    this.$EventBus.$off('updateLayer', this.updateLayer)
  },
  data () {
    return {
      // 页面数据
      page: {},

      // 其他操作
      isMovingCanvas: false, // 画布拖拽
      canvasPosition: {
        x: 300 + 20,
        y: 20,
      },

      isMovingLayer: false, // 图层拖拽
      layerPosition: undefined,
      isResizingLayer: false, // 图层Resize
      layerResize: {
        id: 1,
        position: {
          x: 0,
          y: 0,
        },
        size: {
          width: 300,
          height: 300
        }
      }
    }
  },
  computed: {
    style () {
      const { x, y } = this.canvasPosition
      console.log('canvasPosition:', this.canvasPosition)
      return {
        left: x + 'px',
        top: y + 'px'
      }
    },
  },
  methods: {
    handleWindowKeydown () {

    },
    handleWindowKeyUp () {

    },
    handleWindowMouseMove (event) {
      const { movementX, movementY } = event
      // 移动画布
      if (this.isMovingCanvas) {
        const { x, y } = this.canvasPosition
        this.moveCanvas({
          x: x + movementX,
          y: y + movementY
        })
      }

      // 移动图层
      if (this.isMovingLayer) {
        const { id, x, y } = this.layerPosition
        this.moveLayer({
          id,
          x: x + movementX,
          y: y + movementY
        })
      }

      // Resize图层
      // if (this.isResizingLayer) {
      //   const { id, width, height } = this.layerSize
      //   this.resizeLayer({
      //     id,
      //     width: width + movementX,
      //     height: height + movementY
      //   })
      // }
    },
    handleWindowMouseUp () {
      this.moveCanvas()
      this.moveLayer()
      // this.resizeLayer()
    },
    handleMouseDown (event) {
      this.moveCanvas(this.canvasPosition)
      event.stopPropagation()
    },
    moveLayer (position) {
      this.isMovingLayer = !!position
      if (position) {
        this.layerPosition = position
        const { id, x, y } = position
        const target = this.layers.find(item => item.id === id)
        if (target) {
          target.position.x = x
          target.position.y = y
          this.updateLayer(target)
        }
      }
    },
    resizeLayer (resize) {
      this.isResizingLayer = !!resize
      if (resize) {
        const { id, position: { x, y }, size: { width, height } } = resize
        const target = this.layers.find(item => item.id === id)
        if (target) {
          target.size.width = width
          target.size.height = height
          target.position.x = x
          target.position.y = y
          this.updateLayer(target)
        }
      }
    },
    moveCanvas (position) {
      this.isMovingCanvas = !!position
      if (position) {
        this.canvasPosition = position
      }
    }
  }
}
</script>
<style scoped lang="less">
@navigationBarHeight: 64px;
.editor-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 900;
  background-color: rgb(229, 233, 237);
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .editor {
    position: relative;
    box-sizing: border-box;
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 1920px;
    height: 100%;
    border: 1px solid transparent;

    &:hover {
      border: 1px dotted blue;
      border-radius: 4px;
    }
  }
}
</style>
